const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'wishlistactive';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.product',
  wishlistCount: '.wishlist_count',
};

document.addEventListener('DOMContentLoaded', () => {  
   const wishlist = getWishlist(); 
const wishlistCountElement = document.querySelector(selectors.wishlistCount);
if (wishlistCountElement) {
  wishlistCountElement.textContent = `(${wishlist.length})`;
}


  /*initButtons();
  initGrid();*/
 
});

function CartWishlist() {
  // Check if wishlist section exists
  var wishlistSection = document.querySelector('.wishlist-product');
  if (!wishlistSection) {
    return; // Exit if no wishlist section on page
  }

  // Use event delegation on the wishlist section
  wishlistSection.addEventListener('click', function(ev) {
    // Check if clicked element is a submit button
    if (ev.target.matches('[type="submit"]')) {
      var s = ev.target;
      
      // Find the form (which has the go-to-cart class)
      var p = s.closest('form[class*="go-to-cart-"]');
      if (!p) return;
      
      // Extract section ID from form class
      var formClasses = p.className;
      var match = formClasses.match(/go-to-cart-([\w-]+)/);
      if (!match) return;
      var sectionId = match[1];
      
      // Get elements
      var FB = p.querySelector('.feedback');
      var productContainer = s.closest('.product');
      var aFB = productContainer ? productContainer.querySelector('.feedback.loaded') : null;
      var t = p.querySelector('.icon-times');
      var c = p.querySelector('.icon-check');
      
      function fb(success, html) {
        FB.classList.add(success);
        FB.querySelector('.html').innerHTML = html;
        if (!FB.classList.contains('loaded')) {
          FB.classList.add('open');
          FB.style.height = 'auto';
          var FBht = FB.clientHeight;
          var FBhtpx = FBht + 'px';
          FB.style.height = '0px';
          setTimeout(function () {
            FB.style.height = FBhtpx;
          }, 0);
          setTimeout(function () {
            FB.classList.add('visible','loaded');
          }, 1);
        } else {
          FB.style.height = 'auto';
        }
      }
      
      var id = p.elements['id'].value;
      var properties = {};      
      
      // Collect properties from the form only
      p.querySelectorAll('[name]').forEach((item, i) => {
        if (item.getAttribute('name').includes('properties')) {
          let property = item.getAttribute('name').toString();
          let propName = property.match(/\[(.*?)\]/)[1];
          let propValue = item.value;
          if (item.type === 'checkbox' && item.checked || item.type === 'radio' && item.checked) {
            properties[propName] = propValue;
          } else if (item.type !== 'checkbox' && item.type !== 'radio' && propValue !== '') {
            properties[propName] = propValue;
          }              
        }
      });
      
      if (p.elements['selling_plan']) {
        var sP = p.elements['selling_plan'].value;
      } else {
        var sP = '';
      }
      
      if (p.elements['quantity']) {
        var q = p.elements['quantity'].value;
      } else {
        var q = 1
      }
      
      let skuInput = p.querySelector('input[name="properties[sku]"]');
      if (skuInput) {
        properties['sku'] = skuInput.value;
      }
      
      let formData = {
        'items': [{
          'id': id,
          'selling_plan': sP,
          'quantity': q,
          'properties': properties
        }]
      };
      
      fetch(theme.routes_cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(function(r) {        
        return r.json();        
      }).then(function(j) { 
        if (aFB && !FB.classList.contains('loaded')) {
          aFB.style.height = '0px';
          aFB.classList.remove('visible','loaded')
          aFB.addEventListener('transitionend', function () {
            aFB.classList.remove('open')
          }, {once: true})
        }
        
        s.innerText = theme.language.products_product_ajax_adding;
        s.classList.add('outline');
        s.setAttribute('disabled', true);
        
        if (j.status == 422) {          
          console.log('Request returned an error', j)
          var r = j.description;
          t.classList.remove('hidden');
          c.classList.add('hidden');
          fb('error', r.replace('All 1 ', 'All ').replace(' are', 's are').replace('ss are', 's are'));
          s.innerText = theme.language.products_product_sold_out;
        } else {
          window.setTimeout(function(){ 
            s.innerText = theme.language.products_product_ajax_thanks;
          }, 1000);
          c.classList.remove('hidden');
          t.classList.add('hidden');
          FB.classList.remove('error');
          fb('cart-success',theme.language.products_product_ajax_added + '&nbsp;<a href="' + theme.routes_cart_url + '">' + theme.language.products_product_ajax_view + '</a>');
          window.setTimeout(function(){
            s.classList.remove('outline');
            s.removeAttribute('disabled');
            s.innerText = theme.language.products_product_add_to_cart
          }, 2000);
          
          if (productContainer && productContainer.getAttribute('data-product-type') == 'quick' || theme.cart) {
            var x = true;
          } else {
            var x = false;
          }
          CartDrop(x);
        };
      }).catch(function(err) {
        console.error('!: ' + err)
      });
      
      if (theme.cart) {
        setTimeout(function () {
          fetch(theme.routes_cart_url)
          .then(response => response.text())
          .then(data => {
            CartReload(data)
            imageObserver();
          }).catch(function(err) {
            console.error('!: ' + err)
          });
        }, 1000);
      }
      
      ev.preventDefault();
    }
  });
}



document.addEventListener('readystatechange', e => {
  if(document.readyState === "complete"){
  setTimeout(function(){
      initButtons();
       initGrid();
}, 2000);

  } 
   
});

document.addEventListener('shopify-wishlist:updated', (event) => { 
 // document.querySelector(selectors.wishlistCount).textContent = event.detail.wishlist.length;
  const wishlistCountElement = document.querySelector(selectors.wishlistCount);
if (wishlistCountElement) {
  wishlistCountElement.textContent = event.detail.wishlist.length;
}

  initGrid();
 
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  //console.log('[Shopify Wishlist] Wishlist Product List Loaded', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
 // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ', event.detail.wishlist);
   // document.querySelector(selectors.wishlistCount).textContent = event.detail.wishlist.length;
  const wishlistCountElement = document.querySelector(selectors.wishlistCount);
if (wishlistCountElement) {
  wishlistCountElement.textContent = event.detail.wishlist.length;
}

  

});
document.addEventListener('shopify-wishlist:init-buttons-added-button', (event) => {
 // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ', event.detail.wishlist);
    //alert("button intiated from event");
  

   const buttons = document.querySelectorAll(selectors.button) || [];
 buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    //if (!productHandle) return console.error(' Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
   
  });
});



const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => {
      if (!res.ok) {
        console.log(res);
        // Check if response indicates that product is not found
        if (res.status === 404 ) {
          // Remove the handle from the wishlist array
          const wishlist = getWishlist();
          const index = wishlist.indexOf(handle);
          if (index > -1) {
            wishlist.splice(index, 1);
            console.log(wishlist)
            setWishlist(wishlist);
          }
        }
        // Throw an error to skip the rest of the promise chain
        throw new Error("Product not found");
      }
      return res.text();
    })
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    })
    .catch((err) => {
      console.error(`Shopify Wishlist Failed to load content for handle: ${handle}`, err);
      return ''; // return a placeholder HTML element or null
    });
};


const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  
  if(wishlistProductCards == ''){
        grid.innerHTML  = ' <div class="wishlistempty text-center w-100"><p>Your garage wishlist is empty </p></div>';
  }
  else{
    grid.innerHTML = wishlistProductCards;
    document.querySelectorAll('.lazycontainer').forEach(container => {
  container.classList.add('lazyignore');
  let img = container.querySelector('img');
  if (img) {
    img.classList.add('lazyloaded');
  }
});
let productLoop = document.querySelector('.product-loop');
if (productLoop) {
  productLoop.classList.remove('no-product');
}

CartWishlist();
  }
  
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error(' Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', (event) => {
    
      updateWishlist(productHandle);      
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};


const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;

  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);


};



const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};